"use strict";

exports.__esModule = true;
var _DeviceConnectivityElement = require("./DeviceConnectivityElement");
Object.keys(_DeviceConnectivityElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceConnectivityElement[key]) return;
  exports[key] = _DeviceConnectivityElement[key];
});
var _DeviceConnectivityFields = require("./DeviceConnectivityFields");
Object.keys(_DeviceConnectivityFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceConnectivityFields[key]) return;
  exports[key] = _DeviceConnectivityFields[key];
});
var _DeviceConnectivityThumbnail = require("./DeviceConnectivityThumbnail");
Object.keys(_DeviceConnectivityThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceConnectivityThumbnail[key]) return;
  exports[key] = _DeviceConnectivityThumbnail[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});